// ----------------------------------------------------------------------
// <copyright file='Izenda.PasswordInfo.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var Panel = require('share/components/controls/Izenda.Panel');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var EventUtils = require('EventUtils');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
  var actions = require('modules/Account/Izenda.PasswordInfoActions');
  const { isNil } = require('lodash/fp');

  var Header = function header(props) {
    var localization = props.localization;

    return (
      <div>
        <div>{localization.getText('ACOUNT_MESSAGE_PROVIDE_NEW_PASSWORD_SECURITY_TO_FURTHER_PROCEED')}</div>
        {! isNil(props.message) ? (
          <div className="izenda-Account-errorMessage izenda-Account-errorMessage-info u_textLeft">{props.message}</div>
        ) : null}
      </div>
    );
  };

  var Footer = function footer(props) {
    var localization = props.localization;

    return (
      <div className="u_textRight">
        <button className="btn btn-primary izenda-Account-btn" onClick={props.onClickBack}>
          {localization.getText('ACOUNT_LABEL_BACK')}
        </button>
        <button className="btn btn-primary izenda-Account-btn" onClick={props.onClickSubmit}>
          {localization.getText('ACOUNT_LABEL_SUBMIT')}
        </button>
      </div>
    );
  };

  var PasswordInfo = React.createClass({
    /**
     * Render body.
     */
    renderBody: function() {
      var props = this.props;
      var model = props.store.model;
      var localization = props.localization;

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols="4" className="u_textLeft">
              <label className="validation required">{localization.getText('ACOUNT_LABEL_NEW_PASSWORD')}</label>
            </GridLayout.Col>
            <GridLayout.Col cols="8">
              <ValidateInput
                type="password"
                className="form-control"
                value={model.password}
                onChange={EventUtils.notifyChange(props.onChangePassword, EventUtils.INPUT)}
                field="password"
                validations={AccountConstants.CONSTRAINTS.password}
              />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols="4" className="u_textLeft">
              <label className="validation required">{localization.getText('ACOUNT_LABEL_CONFIRM_NEW_PASSWORD')}</label>
            </GridLayout.Col>
            <GridLayout.Col cols="8">
              <ValidateInput
                type="password"
                className="form-control"
                value={model.confirmPassword}
                onChange={EventUtils.notifyChange(props.onChangeConfirmPassword, EventUtils.INPUT)}
                field="confirmPassword"
                validations={AccountConstants.CONSTRAINTS.confirmPassword}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    },

    render: function() {
      var props = this.props;
      var model = this.props.store.model;
      if (!model.isCurrentStep(AccountConstants.STEP_KEYS.PasswordInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: props.localization
      };

      var footer = {
        component: Footer,
        onClickBack: props.onClickBack,
        onClickSubmit: props.onClickSubmit,
        localization: props.localization
      };

      return (
        <Panel className="izenda-Account-Container" header={header} footer={footer}>
          {this.renderBody()}
        </Panel>
      );
    }
  });

  module.exports = connect(actions)(PasswordInfo);
})();



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.PasswordInfo.jsx